import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

export const healthGuard: CanActivateFn = async () => {
  const http = inject(HttpClient);
  const router = inject(Router);

  try {
    const response = await firstValueFrom(
      http.get(`${environment.apiUrlV1}/health`, { responseType: 'text' }),
    );

    if (response.trim().toUpperCase() === 'OK') {
      return true;
    }
  } catch {
    // Handled below by redirecting to the maintenance page.
  }

  return router.createUrlTree(['/maintenance']);
};
